import React from 'react';

import { Child, PeopleParams } from '../types';
import Modal from '../components/Modal';
import FormCount from '../../Form/FormCount';
import SearchFormWrapper from '../components/SearchFormWrapper';
import { getImage } from '../../utils/pathHelper';
import PeopleIcon from '../images/person.svg';
import { getAdultCountDisplay, getChildrenCountDisplay } from '../utils'
import i18n from '../../i18n';

type SearchFormPeopleProps = {
  people: PeopleParams;
  handleChangePeople: (people: PeopleParams) => void;
  flexGrow?: number;
  flexShrink?: number;
}

const SearchFormPeople: React.FC<SearchFormPeopleProps> = ({ people, handleChangePeople, flexGrow, flexShrink }) => {
  const MAX_CHILD_AGE = 12;
  const [isModalShown, setModalShown] = React.useState<boolean>(false);
  const [adultCount, setAdultCount] = React.useState<number>(people.adult);
  const [children, setChildren] = React.useState<Child[]>(people.children);
  const [submitAttempted, setSubmitAttempted] = React.useState<boolean>(false);

  const allAgesSelected = () => {
    return children.every(child => child.age !== null);
  };

  const handleChangeAdultCount = (count: number) => {
    setAdultCount(count);
    handleChangePeople({ adult: count, children });
  }

  const increaseChildren = () => {
    const newChildren = [...children, { age: null }];
    setChildren(newChildren);
    handleChangePeople({ adult: adultCount, children: newChildren });
  }

  const decreaseChildren = () => {
    const newChildren = children.slice(0, -1);
    setChildren(newChildren);
    handleChangePeople({ adult: adultCount, children: newChildren });
  }

  const handleChildAgeChange = (index: number, e: React.ChangeEvent<HTMLSelectElement>) => {
    const newChildren = children.map((child, i) => {
      if (i === index) {
        return { age: parseInt(e.target.value) };
      }
      return child;
    });
    setChildren(newChildren);
    handleChangePeople({ adult: adultCount, children: newChildren });
  }

  const handleValidationAndSubmit = () => {
    setSubmitAttempted(true);
    if (allAgesSelected()) {
      setModalShown(false);
      setSubmitAttempted(false);
    }
  }

  return (
    <SearchFormWrapper onClick={() => setModalShown(true)} icon={<img src={getImage(PeopleIcon)} />} flexGrow={flexGrow} flexShrink={flexShrink}>
      <div>
        { getAdultCountDisplay(adultCount) }
        {children.length > 0 && (
          <>
            , {getChildrenCountDisplay(children.length)} ({children.map(child => child.age).join(', ')})
          </>
        )}
        <Modal isShown={isModalShown} handleClose={handleValidationAndSubmit} title={''} whiteMode={true}>
          <div>
            <div>
              <FormCount label={i18n.t('base.adult')} count={adultCount} minCount={1} handleNumberChange={handleChangeAdultCount} />
            </div>
            <hr></hr>
            <div>
              <FormCount label={i18n.t('base.child')} count={children.length} minCount={0} handleIncrease={increaseChildren} handleDecrease={decreaseChildren} />
              {children.map((child, i) => {
                return (
                  <div key={i.toString()} className="d-flex align-items-center justify-content-between mb-3">
                    <label className="mr-2 mb-0">{ i18n.t('base.age_of_child', { number: (i + 1) }) }</label>
                    <select
                      className="form-control"
                      onChange={(e) => handleChildAgeChange(i, e)}
                      value={child.age !== null ? child.age : ""}
                      required
                      style={{ maxWidth: '200px', border: submitAttempted && child.age === null ? '1px solid red' : undefined }}
                    >
                      <option value="" disabled>{ i18n.t('base.please_select') }</option>
                      {[...Array(MAX_CHILD_AGE + 1)].map((_, age) => (
                        <option key={age.toString()} value={age}>
                          {age}
                        </option>
                      ))}
                    </select>
                  </div>
                );
              })}
            </div>
            <div className="d-flex justify-content-center mt-4">
              <button
                className="col-12 col-md-5 btn btn-primary rounded-pill font-weight-bold"
                onClick={handleValidationAndSubmit}
              >
                { i18n.t('base.confirm') }
              </button>
            </div>
          </div>
        </Modal>
      </div>
    </SearchFormWrapper>
  );
}

export default SearchFormPeople;
